import React from "react";
import { Lottie } from "lottie-react";

const LottieBox = ({ src, size, style }) => (
  <div style={{ width: size, ...style }}>
    <Lottie src={src} loop autoplay />
  </div>
);

export default LottieBox;
